module.exports = __webpack_public_path__ + "static/media/cabs-icon.3ea6bd0f.PNG";